import React from 'react';

import { UserProvider, useUser } from '../../context/UserContext'

import {
  Redirect
} from "react-router-dom";

export default function ProfileNav() {
  
  const { usuario, cargandoUsuario, setCargandoUsuario, setData, login, setLogin, logout, FBLogin } = useUser();

  if( cargandoUsuario ) {
    return (<div></div>);
  } else {
    if( usuario === null ) {
      return (<Redirect to="/"></Redirect>)
    }
  }
  
  return (
    <div className="box profile_resume">
      <figure class="profile_image">
        { usuario !== null ? <img src={usuario.profile_image} className="profile_image"/> : null }
      </figure>
      { usuario !== null ? <h2>{usuario.first_name}</h2> : null }
      <div class="personal_data">
        <div class="item">
          <span class="label">
          Edad:
          </span>
          <span class="value">
            {usuario.edad} años
          </span>
        </div>
        
        <div class="item">
          <span class="label">
          Apoyando desde:
          </span>
          <span class="value">
            01/2021
          </span>
        </div>
        
        <div class="item">
          <span class="label">
          Signo:
          </span>
          <span class="value">
            {usuario.signo}
          </span>
        </div>
        
        <div class="item">
          <span class="label">
          Vive en:
          </span>
          <span class="value">
            {usuario.location}
          </span>
        </div>
        
        <div class="item">
          <span class="label">
          Profesión:
          </span>
          <span class="value">
            Abogado
          </span>
        </div>
      </div>
      <div className="tags">
        {usuario.likes.map( (item, i) => {
          return (<span key={item.id}>{item.name}</span>)
        })}
      </div>
    </div>
  )
}